import { useAuth } from '../contexts/AuthContext';

const RoleBasedAccess = ({ children, requiredRole = 'admin', fallback = null }) => {
  const { role } = useAuth();

  const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

  if (!allowedRoles.includes(role)) {
    return fallback;
  }

  return children;
};

export default RoleBasedAccess;
